import React from "react";
import { useLocation } from "react-router-dom";
import QPhototModuleSubtopic from "../../QPhotoModuleSubtopic";

const ALL_DM_SUBTOPICS = [
    { name: 'Proposition, Logical connectives and compound propositions', path: '/dm-m1-s1' },
    { name: 'Truth table, tautologies, contradictions and contingencies', path: '/dm-m1-s2' },
    { name: 'Logical equivalences, predicates and quantifiers', path: '/dm-m1-s3' },
    { name: 'Introduction to Sets, Subsets, Cardinality', path: '/dm-m2-s1' },
    { name: 'Set Operations, Properties of Set Operations', path: '/dm-m2-s2' },
    { name: 'Power set and Set identities', path: '/dm-m2-s3' },
    { name: 'Relation – Definition and properties', path: '/dm-m3-s1' },
    { name: 'Equivalence relation, Partial order, Poset and Hasse diagram', path: '/dm-m3-s2' },
    { name: 'Functions - Introduction, Types of Functions, Function Composition and Inverse Functions', path: '/dm-m3-s3' },
    { name: 'Introduction to Graph, Undirected and directed graphs, Weighted graphs, Special graphs', path: '/dm-m4-s1' },
    { name: 'Adjacency and Incidence Matrix, Isomorphism, Subgraph, Connected Components', path: '/dm-m4-s2' },
    { name: 'Degree of a vertex, Handshaking theorem, Paths and cycles in graphs', path: '/dm-m4-s3' },
    { name: 'Planar Graphs, Eulerian graphs and Hamiltonian graphs', path: '/dm-m4-s4' },
    { name: 'Introduction to Trees, Properties of trees, rooted trees, Binary trees', path: '/dm-m5-s1' },
    { name: 'Spanning trees, Minimum spanning trees', path: '/dm-m5-s2' },
    { name: 'Introduction to counting techniques, Permutations and Combinations', path: '/dm-m6-s1' },
    { name: 'Pigeonhole principle, Recurrence relations, Introduction to complexity', path: '/dm-m6-s2' }
];

const DMModuleSubtopic = ({ title, videos, pdfLink, takeaways, questions, exampleVideos }) => {
    const location = useLocation();
    const { subtopics = ALL_DM_SUBTOPICS, subjectPath = '/subject-DMModules' } = location.state || {};

    return (
        <QPhototModuleSubtopic
            title={title}
            videos={videos}
            pdfLink={pdfLink}
            takeaways={takeaways}
            questions={questions}
            exampleVideos={exampleVideos}
            subtopics={subtopics || ALL_DM_SUBTOPICS}
            subjectPath={subjectPath}
        />
    );
};

export default DMModuleSubtopic;
